import React from 'react'
import { FormattedMessage } from 'react-intl'

export default ({ data, onProceed }) => (
  <div>
    <h1 className='Signin__title Head'><FormattedMessage id='bid.agreement_title' /></h1>
    {/* <div style={{ marginBottom: 40 }} dangerouslySetInnerHTML={{ __html: data }} /> */}
    <div className='Payments__text_sm' style={{ marginBottom: 40 }}> <FormattedMessage id='bid.agreement_text' /></div>
    <button type='submit' className='Main__founds-button Button Button_white' onClick={onProceed}><FormattedMessage id='bid.proceed' /></button>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Lot/Agreement.jsx